import { toast } from "react-toastify";
import * as app_consts from "./app_consts";

//url for production
export var url = "";
if (process.env.NODE_ENV === "development")
{
  url = "";
} else
{
  url = window.location.host.split("/")[1];
  if (url)
  {
    url = `/${window.location.host.split("/")[1]}`;
  } else url = process.env.PUBLIC_URL; /// ADD YOUR CPANEL SUB-URL
}

//Function to validate and return errors for a form
export const checkForm = (formData) => {
  let errorState = {};
  Object.keys(formData).forEach((item) => {
    if (formData[item] === null || formData[item] === "")
    {
      errorState[item] = "This field is required";
    }
  });
  return errorState;
};

//Function that returns the first or first two letters from a name
export const findUpper = (string) => {
  let extractedString = [];

  for (var i = 0; i < string.length; i++)
  {
    if (string.charAt(i) === string.charAt(i).toUpperCase() && string.charAt(i) !== " ")
    {
      extractedString.push(string.charAt(i));
    }
  }
  if (extractedString.length > 1)
  {
    return extractedString[0] + extractedString[1];
  } else
  {
    return extractedString[0];
  }
};

//Function that calculates the from current date
export const setDeadline = (days) => {
  let todayDate = new Date();
  var newDate = new Date(todayDate);
  newDate.setDate(newDate.getDate() + days);
  return newDate;
};

// Function to set deadline for projects
export const setDeadlineDays = (deadline) => {
  var currentDate = new Date();
  var difference = deadline.getTime() - currentDate.getTime();
  var days = Math.ceil(difference / (1000 * 3600 * 24));
  return days;
};

//Date formatter function
export const dateFormatterAlt = (date, reverse) => {
  let d = date.getDate();
  let m = date.getMonth();
  let y = date.getFullYear();
  reverse ? (date = m + "-" + d + "-" + y) : (date = y + "-" + d + "-" + m);
  return date;
};

//Date formatter function
export const dateFormatter = (date, reverse) => {
  var dateformat = date.split("-");
  //var date = dateformat[1]+"-"+dateformat[2]+"-"+dateformat[0];
  reverse
    ? (date = dateformat[2] + "-" + dateformat[0] + "-" + dateformat[1])
    : (date = dateformat[1] + "-" + dateformat[2] + "-" + dateformat[0]);
  return date;
};

//Month Names
export const monthNames = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

//todays Date
export const todaysDate = new Date();

// Function to structure date ex : Jun 4, 2011;
export const getDateStructured = (date) => {
  let d = date.getDate();
  let m = date.getMonth();
  let y = date.getFullYear();
  let final = monthNames[m] + " " + d + ", " + y;
  return final;
};

// Function to structure date ex: YYYY-MM-DD
export const setDateForPicker = (rdate) => {
  let d = rdate.getDate();
  d < 10 && (d = "0" + d);
  let m = rdate.getMonth() + 1;
  m < 10 && (m = "0" + m);
  let y = rdate.getFullYear();
  rdate = y + "-" + m + "-" + d;

  return rdate;
};

//current Time
export const currentTime = () => {
  var hours = todaysDate.getHours();
  var minutes = todaysDate.getMinutes();
  var ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12;
  hours = hours ? hours : 12; // the hour '0' should be '12'
  minutes = minutes < 10 ? "0" + minutes : minutes;
  var strTime = hours + ":" + minutes + " " + ampm;
  return strTime;
};

//Percentage calculation
export const calcPercentage = (str1, str2) => {
  let result = Number(str2) / Number(str1);
  result = result * 100;
  return Math.floor(result);
};

//shortens a long string
export const truncate = (str, n) => {
  return str.length > n ? str.substr(0, n - 1) + " " + truncate(str.substr(n - 1, str.length), n) : str;
};

// returns upload url
export const getUploadParams = () => {
  return { url: "https://httpbin.org/post" };
};

// Converts KB to MB
export const bytesToMegaBytes = (bytes) => {
  let result = bytes / (1024 * 1024);
  return result.toFixed(2);
};

export const bulkActionOptions = [
  { value: "suspend", label: "Suspend User" },
  { value: "delete", label: "Delete User" },
];


// ---------------------------- Toast Messages ---------------------------
export const messageToast = (message, type) => {
  if (type === app_consts.SUCCESS)
  {
    toast.success(message, {
      position: "top-center",
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: true,
      theme: "light",
      autoClose: 5000,
      progress: undefined,
    });
  } else if (type === app_consts.FAIL)
  {
    toast.error(message, {
      position: "top-center",
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: true,
      theme: "light",
      autoClose: 5000,
      progress: undefined,
    });
  }
};

// Get Tenant Name from URL
export const getTenantURLPrefix = (index) => {
  const pathParts = window.location.pathname.split("/"); // Split by "/"
  if (index === app_consts.HOME_INDEX)
  {
    const homeIndex = pathParts.indexOf("home"); // Find "home" in the path
    return homeIndex !== -1 ? pathParts[homeIndex + 1] : null; // Get next part
  }
  else if (index === app_consts.NO_AUTH_TENANT_HOME)
  {
    return pathParts.length === 3 ? pathParts[2] : null; // Get first segment if "home" isn't found
  }
  else
  {
    return pathParts.length > 0 ? pathParts[0] : null; // Get first segment if "home" isn't found
  }
};

// Convert to Title Case
export const convertToTitleCase = (str) => {
  // Split the sentence into words
  let words = str?.split(' ');

  // Iterate over each word
  for (let i = 0; i < words?.length; i++)
  {
    // Capitalize the first letter of the word
    words[i] = words[i].charAt(0).toUpperCase() + words[i].slice(1);
  }

  // Join the words back into a sentence
  return words?.join(' ');
};

export const isUrLPrefixValidString = str => str.length >= 5 && /^[a-zA-Z_]+$/.test(str);

export const joinWithCommas = (arr = []) => Array.isArray(arr) ? arr.join(', ') : '';

// Add Three Dots
export const addThreeDots = (str, strLength) => {
  if (str)
  {
    if (str.length > strLength)
    {
      return str.slice(0, strLength) + '...';
    }
  }
  return str;
};

export const formatToSentenceCase = (str) => {
  if (!str || typeof str !== "string") return ""; // Handle null, undefined, numbers, or non-string values

  return str
    .replace(/_/g, " ") // Replace underscores with spaces
    .toLowerCase() // Convert everything to lowercase
    .replace(/(^\w|\.\s*\w)/g, (match) => match.toUpperCase()); // Capitalize first letter of each sentence
};

export const fetchImageAsBase64 = async (imageUrl) => {
  try
  {
    const response = await fetch(imageUrl);
    const blob = await response.blob(); // Convert the response into a Blob
    const reader = new FileReader();

    return new Promise((resolve, reject) => {
      reader.onloadend = () => resolve(reader.result); // Read as Base64
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  } catch (error)
  {
    console.error("Error fetching image:", error);
    return null;
  }
};

export function getFirstPathAfterCom (url) {
  try
  {
    const urlObj = new URL(url);
    const pathSegments = urlObj.pathname.split('/').filter(Boolean);
    return pathSegments.length > 0 ? pathSegments[0] : null;
  } catch (error)
  {
    console.error("Invalid URL:", error);
    return null;
  }
}

//REGEX for EMPTY or NULL input
export const EMPTYNULLREGEX = /^\s*$/;

export const formatNumber = (value) => {
  const num = parseFloat(value);
  if (isNaN(num)) return '0.00';
  return num.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

export const getSelectedOption = (value, options) => {
  return options?.find(option => option.value === value) || null;
};

export const isEmpty = (value) => {
  if (!value) return true;
  if (Array.isArray(value)) return value.length === 0;
  if (typeof value === "object") return Object.keys(value).length === 0;
  return false;
};